import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { trpcClient } from '../../utils/trpc'
import type { InitialData } from './types'

interface SidebarStore {
	state: InitialData
	error?: string
	initialize: () => Promise<void>
	clearError: () => void
}

export type SidebarStoreInstance = ReturnType<typeof createSidebarStore>

export const createSidebarStore = () => {
	return create<SidebarStore>()(
		devtools(
			(set) => ({
				// Initial state
				state: { menuItems: [], bottomActions: [] },
				error: null,

				// Actions
				initialize: async () => {
					try {
						const data = await trpcClient.client.sidebar.initialize.query()
						set({ state: data })
					} catch (error) {
						console.error('Failed to initialize sidebar:', error)
						set({
							error: error instanceof Error ? error.message : 'Failed to initialize sidebar',
						})
					}
				},

				clearError: () => {
					set({ error: undefined })
				},
			}),
			{ name: 'sidebar-store' },
		),
	)
}
